import React, { Component } from "react";
import "../App.css";
import HeroImg from "../images/main-banner.png";

class Hero extends Component {
  render() {
      return (
        <section>
          <img className="Hero" src={HeroImg} alt="banner"></img>
          <div className="Hero-Title">
            <h1>Harness your potential and mind through books</h1>
            <button>Learn More</button>
          </div>
        </section>
      );
  }
}

export default Hero;
